import api from '@/lib/axios';
import { UserAlert, AlertsResponse } from '@/types/alert';

export const alertsApi = {
  /**
   * Get all alerts with pagination
   */
  getAlerts: async (page = 0, size = 20): Promise<AlertsResponse> => {
    const response = await api.get('/alerts', {
      params: { page, size },
    });
    return response.data;
  },

  /**
   * Get unread alerts
   */
  getUnreadAlerts: async (): Promise<UserAlert[]> => {
    const response = await api.get('/alerts/unread');
    return response.data;
  },

  /**
   * Get unread alerts count
   */
  getUnreadCount: async (): Promise<number> => {
    const response = await api.get('/alerts/unread/count');
    return response.data.count;
  },

  /**
   * Mark an alert as read
   */
  markAsRead: async (alertId: string): Promise<void> => {
    await api.put(`/alerts/${alertId}/read`);
  },

  /**
   * Mark all alerts as read
   */
  markAllAsRead: async (): Promise<void> => {
    await api.put('/alerts/read-all');
  },

  /**
   * Delete an alert
   */
  deleteAlert: async (alertId: string): Promise<void> => {
    await api.delete(`/alerts/${alertId}`);
  },
};
